import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";

export default function ModuleEmptyPage() {
  const route_navigate = useNavigate();

  return (
    <div className="flex flex-column align-items-center justify-content-center w-full h-full bg-blue-50">
      <div className="text-4xl font-bold text-red-600">查無頁面 !!</div>
      <Button
        className="p-button-main px-4 mt-4"
        type="button"
        label="回首頁"
        onClick={() => route_navigate("/home")}
      />
    </div>
  );
}
